const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    //查询消费统计
    async getConsumerStatistic({ rootState }, params = {}) {
      const data = await rootState.http("/message/support/consumerStatistic", params);
      return data;
    },
    //查询消息套餐
    async getMessageSetItem({ rootState }, params = {}) {
      const data = await rootState.http("/message/support/queryMessageSetItem", params);
      return data;
    },
    //创建充值订单
    async createRecharge({ rootState }, params = {}) {
      const data = await rootState.http("/message/support/createRechargeOrder", params);
      return data;
    },
    // //获取订单支付结果
    // async getPaymentSuccess({ rootState, commit }, params = {}) {
    //   const data = await rootState.http("/message/support/getRechargeOrderPaymentSuccess", params);
    //   return data;
    // },
    //获取充值记录
    async getRechargeOrder({ rootState }, params = {}) {
      const data = await rootState.http("/message/support/queryRechargeOrder", params);
      return data;
    },
    //获取消费记录
    async getConsumerLogger({ rootState }, params = {}) {
      const data = await rootState.http("/message/support/queryConsumerLogger", params);
      return data;
    },
    //获取支付结果
    async getPaymentsuccess({ rootState }, params = {}) {
      const data = await rootState.http("/message/support/getRechargeOrderPaymentSuccess", params);
      return data;
    }
  }
};
export default store;
